import React, { Component, cloneElement } from "react";
import {
  List,
  Datagrid,
  CreateButton,
  TextField,
  DateField,
  ReferenceField,
  downloadCSV,
  ExportButton,
  EditButton,
  TopToolbar,
  RefreshButton,
  AutocompleteInput,
  Filter,
  ReferenceInput,
  SelectInput,
  NumberInput,
  DateInput,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import {
  GetCurrentUserRoles,
  monthList,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  getCurrencySymbol,
} from "../common/common";

const selectInputStyle = {
  width: 200,
};

const PriceUpdateFilter = (props) => {
  // console.log("LoyaltyPointsFilter prop===>", props);
  return (
    <Filter {...props}>
      <SelectInput
        style={selectInputStyle}
        source="client_category_code"
        label="Customer Type"
        choices={[
          { id: "DISTRIBUTEUR", name: "DISTRIBUTEUR" },
          { id: "ENTREPRISE PME", name: "ENTREPRISE PME" },
          { id: "GRANDE SURFACE", name: "GRANDE SURFACE" },
          { id: "PROMOTEUR DIRECT", name: "PROMOTEUR DIRECT" },
          { id: "PROMOTEUR FRANCHISE", name: "PROMOTEUR FRANCHISE" },
          { id: "REVENDEUR DIRECT", name: "REVENDEUR DIRECT" },
          { id: "REVENDEUR FRANCHISE", name: "REVENDEUR FRANCHISE" },
        ]}
      />
      <SelectInput
        style={selectInputStyle}
        source="material_description"
        label="Material Description"
        choices={[
          {
            id: "Ciment LAFARGE 42,5 50 kgs",
            name: "Ciment LAFARGE 42,5 50 kgs",
          },
          {
            id: "Ciment LAFATRA 32,5 50 kgs",
            name: "Ciment LAFATRA 32,5 50 kgs",
          },
          {
            id: "Ciment LOVA 22,5 Sac 50kgs",
            name: "Ciment LOVA 22,5 Sac 50kgs",
          },
          {
            id: "Ciment MANDA 42,5 Sac 50kgs",
            name: "Ciment MANDA 42,5 Sac 50kgs",
          },
          {
            id: "Ciment ORIMBATO 32,5 Sac 50kgs",
            name: "Ciment ORIMBATO 32,5 Sac 50kgs",
          },
          {
            id: "Ciment ORIMBATO 42,5 Sac 50kgs",
            name: "Ciment ORIMBATO 42,5 Sac 50kgs",
          },
        ]}
      />
      <SelectInput
        style={selectInputStyle}
        source="material_number"
        label="Material Number"
        choices={[
          { id: "5986", name: "5986" },
          { id: "20934", name: "20934" },
          { id: "20935", name: "20935" },
          { id: "24549", name: "24549" },
          { id: "24648", name: "24648" },
          { id: "24712", name: "24712" },
        ]}
      />
      <SelectInput
        style={selectInputStyle}
        source="name"
        label="Region Name"
        choices={[
          { id: "AMBOSITRA", name: "AMBOSITRA" },
          { id: "ANTANANARIVO", name: "ANTANANARIVO" },
          { id: "ANTSIRABE", name: "ANTSIRABE" },
          { id: "ANTSOHIHY", name: "ANTSOHIHY" },
          { id: "BEFANDRIANA NORD", name: "BEFANDRIANA NORD" },
          { id: "DIEGO", name: "DIEGO" },
          { id: "FARAFANGANA", name: "FARAFANGANA" },
          { id: "FIANARANTSOA", name: "FIANARANTSOA" },
          { id: "MAEVATANANA", name: "MAEVATANANA" },
          { id: "MAJUNGA", name: "MAJUNGA" },
          { id: "MANAKARA", name: "MANAKARA" },
          { id: "MANDRITSARA", name: "MANDRITSARA" },
          { id: "MORAMANGA", name: "MORAMANGA" },
          { id: "MORONDAVA", name: "MORONDAVA" },
          { id: "TAMATAVE", name: "TAMATAVE" },
          { id: "TULEAR", name: "TULEAR" },
          { id: "VOHEMAR", name: "VOHEMAR" },
        ]}
      />
      <SelectInput
        style={selectInputStyle}
        source="status"
        label="Status"
        choices={[
          { id: true, name: "True" },
          { id: false, name: "False" },
        ]}
      />
      <DateInput source="created_at_from" label="Created at from" />
      <DateInput source="created_at_to" label="Created at to" />
      <DateInput source="updated_at_from" label="Updated at from" />
      <DateInput source="updated_at_to" label="Updated at to" />
    </Filter>
  );
};

class PostAction extends Component {
  render() {
    const {
      data,
      resource,
      filterValues,
      total,
      maxResults,
      currentSort,
      exporter,
      permanentFilter,
      showFilter,
      displayedFilters,
      filters,
      basePath,
    } = this.props;
    const csvResource = "empty_data";
    return (
      <React.Fragment>
        <TopToolbar>
          {filters &&
            cloneElement(filters, {
              resource,
              showFilter,
              displayedFilters,
              filterValues,
              context: "button",
            })}
          <RefreshButton />
          <ExportButton />
          <CreateButton basePath={basePath} />
        </TopToolbar>
      </React.Fragment>
    );
  }
}

const FormattedCurrencyNumberCustom = (props) => {
  // console.log('props inside FormattedCurrencyNumberCustom===>', props);
  // console.log('record inside FormattedCurrencyNumberCustom===>', record);
  const currProps = props.record.price_after_tax;
  // const value = currProps?.value;
  const direction =
    currProps && currProps?.currencyDirection
      ? currProps.currencyDirection
      : "left";
  const thousandSep = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(currProps);
  return (
    <span className="custom-formated-currency">
      {direction === "right" && <span>{thousandSep}</span>}
      {direction !== "right" && <span>{thousandSep}</span>}
    </span>
  );
};

const FormattedMatNoField = (props) => {
  // console.log('props inside FormattedMatNo===>', parseInt(props.record.material_number));
  const currProps = parseInt(props.record.material_number);
  return <span>{currProps}</span>;
};

class PriceUpdateList extends Component {
  render() {
    const { props, permissions } = this;
    const noOftargets = [...Array(3).keys()];
    const curr = getCurrencySymbol();
    console.log("curr===>", curr);
    let roleData = GetCurrentUserRoles();
    let editBtn = false;
    if (roleData.indexOf("$csa") > -1 || roleData.indexOf("$ca") > -1) {
      editBtn = true;
    }
    return (
      <React.Fragment>
        <Scrollbars class="scroll-container">
          <List
            {...props}
            sort={{ field: "id", order: "DESC" }}
            actions={<PostAction permissions={props} />}
            filters={<PriceUpdateFilter />}
            title="Price Update List"
            bulkActionButtons={false}
          >
            <Datagrid rowClick="show">
              <TextField source="name" label="Region Name" />
              <TextField source="client_category_code" label="Customer Type" />
              <FormattedMatNoField
                source="material_number"
                label="Material Number"
              />
              <TextField
                source="material_description"
                label="Material Description"
              />
              <FormattedCurrencyNumberCustom
                source="price_after_tax"
                label={`Amount(${curr})`}
              />
              <TextField source="status" label="Status" />
              <DateField source="created_at" label="Created at" allowEmpty />
              <DateField source="updated_at" label="Updated at" allowEmpty />
              <EditButton label="Edit" />
            </Datagrid>
          </List>
        </Scrollbars>
      </React.Fragment>
    );
  }
}

export default PriceUpdateList;
